module.exports = __webpack_public_path__ + "img/epasnets-white.8e6e9506.png";